import { render } from "./DeprecationBanner.vue?vue&type=template&id=5dd93ff5&scoped=true&ts=true"
import script from "./DeprecationBanner.vue?vue&type=script&lang=ts"
export * from "./DeprecationBanner.vue?vue&type=script&lang=ts"

import "./DeprecationBanner.vue?vue&type=style&index=0&id=5dd93ff5&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dd93ff5"]])

export default __exports__